import { Text } from '@chakra-ui/react';
import React from 'react';
const DEFAULT_SETTINGS = {
    original: {
        variant: 'dk-800-rg-3',
    },
    light: {
        variant: 'lt-500-rg-3',
    },
};
const AVAILABLE_TAGS = ['light'];
export const removeTagsFromSmartText = (label) => {
    const tagNames = AVAILABLE_TAGS.join('|');
    const regex = new RegExp(`</?(${tagNames})>`, 'g');
    return label.replace(regex, '');
};
const SmartText = ({ label, labelSettings = DEFAULT_SETTINGS }) => {
    const pattern = new RegExp(AVAILABLE_TAGS.map((tag) => `(<${tag}>.*?<\\/${tag}>)`).join('|'), 'g');
    const parts = label.split(pattern).filter(Boolean);
    return (React.createElement(React.Fragment, null, parts.map((part, i) => {
        for (const tag of AVAILABLE_TAGS) {
            if (part.startsWith(`<${tag}>`) && part.endsWith(`</${tag}>`)) {
                const content = part.replace(new RegExp(`</?${tag}>`, 'g'), '');
                return (React.createElement(Text, { as: "span", key: i, ...labelSettings?.[tag] }, content));
            }
        }
        return (React.createElement(Text, { as: "span", key: i, ...labelSettings?.original }, part));
    })));
};
export default SmartText;
